var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVendor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 95,
    height: 93.2,
    viewBox: "0 0 95 93.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-916.5 777)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M2.5,96.6h95v-6h-6V39.9L58.3,30.8V90.5H53.8V3.4l-45.3,9V90.6h-6ZM77.9,47.7h6v7.8h-6Zm0,13.9h6v7.8h-6Zm0,13.9h6v7.8h-6ZM65.8,47.7h6v7.8h-6Zm0,13.9h6v7.8h-6Zm0,13.9h6v7.8h-6ZM40.2,20h6v7.8h-6Zm0,13.9h6v7.8h-6Zm0,13.8h6v7.8h-6Zm0,13.9h6v7.8h-6ZM28.1,20h6v7.8h-6V20Zm0,13.9h6v7.8h-6V33.9Zm0,13.8h6v7.8h-6V47.7Zm0,13.9h6v7.8h-6V61.6ZM16,20h6v7.8H16Zm0,13.9h6v7.8H16Zm0,13.8h6v7.8H16Zm0,13.9h6v7.8H16Zm9.4,13.9H36.9V90.6H25.4Z",
    transform: "translate(914 -780.4)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/vendor.411b5e0fc18e1733d2f18022fba26fec.svg";
export { ForwardRef as ReactComponent };